import { render, staticRenderFns } from "./DataFieldEdit.vue?vue&type=template&id=123e8ba7&"
import script from "./DataFieldEdit.vue?vue&type=script&lang=js&"
export * from "./DataFieldEdit.vue?vue&type=script&lang=js&"
import style0 from "./DataFieldEdit.vue?vue&type=style&index=0&id=123e8ba7&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports